export class OSMTagSet {
    constructor(initial = {}) {
        this.raw = initial;
    }
    readValue(key) {
        const value = this.raw[key];
        return value?.trim();
    }
    readString(key, defaultValue) {
        const value = this.raw[key];
        return value?.trim() ?? defaultValue;
    }
    readInt(key, defaultValue) {
        const val = this.readValue(key);
        if (val !== undefined) {
            const parsed = parseInt(val, 10);
            return isNaN(parsed) ? defaultValue : parsed;
        }
        return defaultValue;
    }
    readFloat(key, defaultValue) {
        const val = this.readValue(key);
        if (val !== undefined) {
            const parsed = parseFloat(val);
            return isNaN(parsed) ? defaultValue : parsed;
        }
        return defaultValue;
    }
    readBool(key, defaultValue) {
        const val = this.readValue(key)?.toLowerCase();
        if (val === undefined)
            return defaultValue;
        if (["1", "yes", "true"].includes(val))
            return true;
        if (["0", "no", "false"].includes(val))
            return false;
        return defaultValue;
    }
    has(key) {
        return Object.prototype.hasOwnProperty.call(this.raw, key);
    }
    toJSON() {
        return { ...this.raw };
    }
}
//# sourceMappingURL=osm.tagset.js.map